import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import WarehouseApp from './App';
import { AuthProvider } from './AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <WarehouseApp />
    </AuthProvider>
  </React.StrictMode>
);